import { useMemo } from 'react';
import { Bar, BarChart, CartesianGrid, Tooltip, XAxis, YAxis } from 'recharts';
import { DashboardWrapper, RotatedAxisTick } from '../../components';
import { PERMISSIONS } from '../../constants';
import useDashboardContext from '../../hooks/useDashboardContext';

const color = "#79CF62";

const chartMargin = { top: 20, right: 20, bottom: 50, left: 20 };
const yAxisDomain = [0, 'auto'];
const yAxisTickFormatter = (value) => `${value}`;
const tooltipFormatter = (value) => `${value} abastecimentos`;
const tooltipLabelFormatter = (label) => `Combustível: ${label}`;
const tooltipItemStyle = { color: '#333', fontSize: '14px' };
const tooltipContentStyle = {
  backgroundColor: '#fff',
  border: '1px solid #ddd',
  borderRadius: '5px',
  padding: '5px 10px',
};

export const FillinsByFuelChart = () => {
  const { fuelData } = useDashboardContext();

  const chartData = useMemo(() => {
    if (!fuelData) return null;
    return fuelData
      .filter(f => f.id !== '0' && f.totalFillins > 0)
      .sort((a, b) => b.totalFillins - a.totalFillins);
  }, [fuelData]);

  const chartContent = useMemo(() => (
    <BarChart data={chartData || []} margin={chartMargin}>
      <CartesianGrid strokeDasharray="3 3" stroke="#dfdfdf" />
      <XAxis dataKey="name" tick={<RotatedAxisTick fontSize={12} />} interval={0} height={60} />
      <YAxis width={40} domain={yAxisDomain} tickFormatter={yAxisTickFormatter} />
      <Tooltip
        formatter={tooltipFormatter}
        labelFormatter={tooltipLabelFormatter}
        itemStyle={tooltipItemStyle}
        contentStyle={tooltipContentStyle}
      />
      <Bar
        dataKey="totalFillins"
        fill={color}
        barSize={40}
        name="Abastecimentos"
        isAnimationActive={true}
      />
    </BarChart>
  ), [chartData]);

  return (
    chartData && chartData.length > 0 && (
      <DashboardWrapper
        permission={PERMISSIONS.FILLINS_CHART}
        title='Abastecimentos por Combustível'
        width='45%'
        link='/report-fillin-by-fuel'
        content={chartContent}
      />
    )
  );
};
